/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type GetCardsStatus = typeof GetCardsStatus[keyof typeof GetCardsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCardsStatus = {
  INACTIVE: 'INACTIVE',
  ACTIVE: 'ACTIVE',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  LOCKED: 'LOCKED',
  SUSPENDED: 'SUSPENDED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;
